<div class="panel-background">
  <div class="no-print">
    <breadcrumb-actions-timepicker
      [breadCrumbValues]="breadCrumbValues"
      [testInfoValue]="testInfoValue"
      [timePickerValue]="timePickerValue"
    ></breadcrumb-actions-timepicker>
  </div>
  <div class="no-print filter-header" *ngIf="reports.length > 0">
    <div class="filter">
      <span class="switcher-title">Show:</span>
      <mat-button-toggle-group
        class="perspective-toggle"
        name="viewSwitch"
        #group
        [value]="selectedFilter"
        (change)="filterType($event.value)"
      >
        <mat-button-toggle value="">All </mat-button-toggle>
        <mat-button-toggle
          value="pass"
          [disabled]="passedState.length === 0"
          [ngClass]="{ 'disbaled-text': passedState.length === 0 }"
          >Pass
        </mat-button-toggle>
        <mat-button-toggle
          value="fail"
          [ngClass]="{ 'disbaled-text': failedState.length === 0 }"
          [disabled]="failedState.length === 0"
          >Fail
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <div class="sticky-bar">
      <div>
        <button
          [useExistingCss]="true"
          [openNewTab]="true"
          printSectionId="print-section"
          ngxPrint
          mat-button
          color="primary"
          class="font-600"
        >
          <i class="mdi mdi-printer icon"></i>
          Print
        </button>
      </div>
      <div
        *ngIf="type === 'truespeed' || (type === 'udp' && mode === 'client-to-ma')"
        style="display: flex"
      >
        <div *ngIf="!hideExpertView">
          <mat-checkbox color="primary" class="icon-font checkbox-alter" [(ngModel)]="expertView"
            >Expert View
          </mat-checkbox>
        </div>
        <div class="classic-report" *ngIf="type === 'truespeed'">
          <mat-checkbox color="primary" class="icon-font checkbox-alter" [(ngModel)]="classicReport"
            >Classic Report
          </mat-checkbox>
        </div>
      </div>
    </div>
  </div>
  <div class="panel" *ngIf="reports.length > 0 && filteredReports.length > 0">
    <div class="no-print header">
      <div class="list-headers">
        <div
          *ngFor="let report of filteredReports"
          [ngClass]="{ 'active-report': reportName === report?.name }"
        >
          <a class="list" (click)="openReport(report)"
            ><i
              class="mdi"
              [ngClass]="{
                'mdi-check-circle-outline success-report-icon': report?.reportStatus === 'pass',
                'mdi-alert-circle-outline failed-report-icon': report?.reportStatus === 'fail',
                'mdi-minus-circle-outline inconclusive-report-icon':
                  report?.reportStatus === 'inconclusive'
              }"
            ></i>
            {{ report?.name }}
          </a>
        </div>
      </div>
    </div>
    <div class="report-panel" *ngIf="!isLoading && scheduleId && runId" id="print-section">
      <nrwl-truespeed-reports
        *ngIf="type === 'truespeed' && reportStatus !== 'inconclusive'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [onDemandTest]="onDemandTest"
      ></nrwl-truespeed-reports>
      <nrwl-voip-reports
        *ngIf="type === 'voip' && reportStatus !== 'inconclusive'"
        [expertView]="expertView"
        [reportName]="reportName"
      ></nrwl-voip-reports>
      <nrwl-y1564-reports
        *ngIf="type === 'y1564'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [reportName]="reportName"
        [onDemandTest]="onDemandTest"
      ></nrwl-y1564-reports>
      <nrwl-bert-reports
        *ngIf="type === 'bert'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [reportName]="reportName"
        [onDemandTest]="onDemandTest"
      ></nrwl-bert-reports>
      <nrwl-udp-final
        *ngIf="type === 'udp'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [reportName]="reportName"
        [onDemandTest]="onDemandTest"
      ></nrwl-udp-final>
      <nrwl-rfc2544-reports
        *ngIf="type === 'rfc2544'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [reportName]="reportName"
        [onDemandTest]="onDemandTest"
      ></nrwl-rfc2544-reports>
      <nrwl-http-final-reports
        *ngIf="type === 'http' && reportStatus !== 'inconclusive'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [onDemandTest]="onDemandTest"
      ></nrwl-http-final-reports>
      <nrwl-ftp-final-reports
        *ngIf="type === 'ftp' && reportStatus !== 'inconclusive'"
        [expertView]="expertView"
        [scheduleId]="scheduleId"
        [runId]="runId"
        [reportStartTime]="reportStartTime"
        [classicReport]="classicReport"
        [testName]="_testName"
        [onDemandTest]="onDemandTest"
      ></nrwl-ftp-final-reports>
      <!-- <div *ngIf="reportStatus === 'inconclusive'" class="no-data">
        <i class="mdi mdi-file-multiple icon-font"></i>
        <span class="no-data-msg"> Report data not available</span>
      </div> -->
    </div>
  </div>
</div>
<div *ngIf="!isLoading && reports.length === 0" class="no-data">
  <i class="mdi mdi-file-multiple icon-font"></i
  ><span class="no-data-msg"> No reports found for this test</span>
</div>
<div class="loader-content" *ngIf="isLoading">
  <div class="spinner">
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
  <div class="loader-text">
    <div class="text-message">Getting Final Reports</div>
  </div>
</div>
